import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-RegularItalic.ttf') format('truetype');
    font-weight: 400;
    font-style: italic;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-BoldItalic.ttf') format('truetype');
    font-weight: 700;
    font-style: italic;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-Extrabold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-NarrowRegular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-stretch: condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-NarrowMedium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-stretch: condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-NarrowBold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-stretch: condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-NarrowExtrabold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
    font-stretch: condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-NarrowBlack.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-stretch: condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-CondRegular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-stretch: extra-condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-CondMedium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-stretch: extra-condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-CondBold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-stretch: extra-condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-CondExtrabold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
    font-stretch: extra-condensed;
  }

  @font-face {
    font-family: 'Klean';
    src: url('/assets/fonts/Klean/Klean-CondBlack.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-stretch: extra-condensed;
  }

  @font-face {
    font-family: 'Kaercher-Icons';
    src: url('../app/assets/fonts/icons/kaercher_system_icons.eot?67423101');
    src: url('../app/assets/fonts/icons/kaercher_system_icons.eot?67423101#iefix') format('embedded-opentype'),
    url('../app/assets/fonts/icons/kaercher_system_icons.woff?67423101') format('woff'),
    url('../app/assets/fonts/icons/kaercher_system_icons.ttf?67423101') format('truetype'),
    url('../app/assets/fonts/icons/kaercher_system_icons.svg?67423101#kaercher_system_icons') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  html {
    height: 100%;
  }

  body {
    position: absolute;
    top:0;
    bottom:0;
    right:0;
    left:0;
  }

  #root {
    height: 100%;
  }

  .custom-antd-notification-error-message {
    // Title
    .ant-notification-notice-message {
      font-family: ${(props): string => props.theme.fonts.notificationErrorTitle};
      font-size: ${(props): string => props.theme.fontSizes.notificationErrorTitle};
      white-space: pre-wrap;
    }

    // Body
    .ant-notification-notice-description {
      font-family: ${(props): string => props.theme.fonts.notificationErrorBody};
      font-size: ${(props): string => props.theme.fontSizes.notificationErrorBody};
      white-space: pre-wrap;
    }
  }
`;
